
import { Component, Emit, namespace, Prop, Vue } from 'nuxt-property-decorator'
import FilterButton from '~/components/comparator/filters/FilterButton.vue'
import IconCheckMark from '~/components/icons/IconCheckMark.vue'
import UiDropdown from '~/components/ui/UIDropdown/UiDropdown.vue'
import OfferModal from '~/components/filters/OfferModal.vue'
import IconSortBy from '~/components/icons/IconSortBy.vue'
import { OnCreated } from '~/core/vue.types'
import { OfferMobileSort, OfferTypeByShortName, OfferTypeKey } from '~/core/offer.types'
import { namespace as offerListNamespace } from '~/store/modules/Amp/OfferList'
import BottomSheet from '~/components/common/BottomSheet.vue'
import SkeletonBox from '~/components/comparator/SkeletonBox.vue'
import UiDropdownItem from '~/components/ui/UIDropdown/UiDropdownItem.vue'
import UiDropdownHandle from '~/components/ui/UIDropdown/UiDropdownHandle.vue'
import { MOBILE_SORTS, HOME_SORTS, BUNDLE_SORTS } from '~/core/config/sorts'
import { AlButton } from '~/components/ui'

const OfferListNamespace = namespace(offerListNamespace)

@Component({
  components: {
    UiDropdownHandle,
    UiDropdownItem,
    SkeletonBox,

    BottomSheet,
    IconCheckMark,
    UiDropdown,
    OfferModal,
    IconSortBy,
    FilterButton,
    AlButton,
  },
})
export default class ComparatorSortBy extends Vue implements OnCreated {
  @Prop({
    required: true,
    type: String,
  })
  protected selectedOfferType!: OfferTypeKey

  private isModalSortShow = false
  private offerSorts: OfferMobileSort[] = []
  private selectedSorting = 'low_price'
  private selectedSortingInModal = 'low_price'

  get sortConfig () {
    switch (this.selectedOfferType) {
      case OfferTypeByShortName.mobile:
        return MOBILE_SORTS
      case OfferTypeByShortName.home:
        return HOME_SORTS
      case OfferTypeByShortName.bundle:
        return BUNDLE_SORTS
      default:
        return MOBILE_SORTS
    }
  }

  onBtnSortClick () {
    this.isModalSortShow = true
    this.selectedSortingInModal = this.selectedSorting
    return true
  }

  selectedSortName (value: string) {
    const label = this.offerSorts.find((s: OfferMobileSort) => s.value === value)?.label
    return label && this.$t(label)
  }

  @OfferListNamespace.Mutation('SET_OFFERS_SORT')
  setSort!: (sort: string) => void

  @OfferListNamespace.Getter('GET_OFFERS_COUNT')
  readonly offersCount!: number

  onDoneClick () {
    this.selectedSorting = this.selectedSortingInModal
    this.isModalSortShow = false
    this.setSort(this.selectedSorting)
  }

  @Emit('on-sort-change')
  onSortSelectedEvent (event: any) {
    this.selectedSortingInModal = event.target.value
  }

  @Emit('on-sort-change')
  onSortSelected (sort: any) {
    this.isModalSortShow = false
    this.selectedSorting = sort
    this.setSort(this.selectedSorting)
  }

  created () {
    this.offerSorts = this.sortConfig
    this.selectedSorting = this.offerSorts[0] ? this.offerSorts[0].value : 'low_price'
    this.setSort(this.selectedSorting)
  }
}
